import { useEffect, useState } from "react";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import { useI18n } from "@/lib/i18n";

export default function Magazine() {
  const { lang } = useI18n();
  const [articles, setArticles] = useState([]);
  useEffect(() => { api.get("/articles").then((r) => setArticles(r.data)); }, []);

  return (
    <div className="min-h-screen overflow-x-hidden">
      <Header />
      <section className="pt-32 pb-12 px-6 md:px-12 lg:px-20" data-testid="magazine-page">
        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
            <div className="lg:col-span-7">
              <div className="eyebrow text-[var(--dsf-orange)] mb-3">The Magazine</div>
              <h1 className="font-serif text-5xl md:text-7xl text-[var(--dd-green)] leading-[1.02]">
                {lang === "fr" ? "Histoires, terroirs et inspirations." : "Stories, terroirs and inspirations."}
              </h1>
            </div>
            <div className="lg:col-span-5">
              <p className="text-[var(--dsf-text-secondary)] text-lg leading-relaxed">
                {lang === "fr" ? "Le journal de bord de notre cuisine. Reportages exclusifs, portraits de producteurs et carnets de voyage." : "Our kitchen's logbook. Exclusive reports, producer portraits and travel diaries."}
              </p>
            </div>
          </div>
        </Reveal>
      </section>

      {/* Uniform compact grid */}
      <section className="px-6 md:px-12 lg:px-20 pb-24">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 md:gap-7">
          {articles.map((a, i) => (
            <Reveal key={i} delay={i * 80}>
              <a href="#" className="block group" data-testid={`magazine-article-${i}`}>
                <div className="aspect-[4/5] overflow-hidden mb-3">
                  <img src={a.image} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-[var(--dsf-orange)] mb-1.5">{a.category} · {a.read_time} min</div>
                <h3 className="font-serif text-base md:text-lg text-[var(--dd-green)] font-semibold leading-tight group-hover:text-[var(--dsf-orange)] transition-colors">
                  {lang === "fr" ? a.title : a.title_en}
                </h3>
                <p className="text-xs text-[var(--dsf-text-secondary)] mt-1.5 line-clamp-2">{lang === "fr" ? a.excerpt : a.excerpt_en}</p>
                <div className="text-[10px] text-[var(--dsf-text-muted)] mt-2">{a.date}</div>
              </a>
            </Reveal>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
